import Logo from "../../assets/letterhead.webp";
import "./HeaderMain.scss";

const Header = () => (
  <header className="header">
    <img
      src={Logo}
      alt="Versus Race Team"
      decoding="async"
    />
  </header>
);

export default Header;